import { HttpClient, HttpContext, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { SignatoryTypeRole } from "../model/signatory-type-role";
import { SignatoryTypeRoleFilter } from "../model/signatory-type-role-filter";
import { SignatoryTypeRoleUsedInEnvelope, SignatoryTypeRoleUsedInEnvelopeFilter } from "../model/signatory-type-role-used-in-envelope";
import { SKIP_ERROR_TOAST } from "src/app/services/http-error-options";

const CONTROLLER = 'signatorytyperole';
@Injectable({
    providedIn: 'root'
})
export class SignatoryTypeRoleService {
    constructor(private http: HttpClient) { }

    OnInit() {
    }

    public get(): Observable<SignatoryTypeRole[]> {
        return this.http.get<any>(CONTROLLER).pipe(
            map(response => response.value),
            catchError(this.handleError)
        );
    }

    public getWithFilter(filter: SignatoryTypeRoleFilter | null, listDetails: boolean): Observable<SignatoryTypeRole[]> {
        let params = new HttpParams();

        params = params.set('listDetails', listDetails);
        
        if (filter?.take !== undefined && filter?.take !== null) {
            params = params.set('take', filter.take.toString());
        }
        if (filter?.skip !== undefined && filter?.skip !== null) {
            params = params.set('skip', filter.skip.toString());
        }
        if (filter?.active !== undefined && filter?.active !== null) {
            params = params.set('active', filter.active.toString());
        }
        if (filter?.inactive !== undefined && filter?.inactive !== null) {
            params = params.set('inactive', filter.inactive.toString());
        }
        if (filter?.name) {
            params = params.set('name', filter.name);
        }

        return this.http.get<any>(CONTROLLER, { params }).pipe(
            map(response => response.value),
            catchError(this.handleError)
        );
    }

    public addSignatoryTypeRole(payload: { name: string }): Observable<any> {
        return this.http.post(CONTROLLER, payload, {
            context: new HttpContext().set(SKIP_ERROR_TOAST, true),
        }).pipe(
            catchError(this.handleError)
        );
    }

    public editSignatoryTypeRole(id: number, payload: { name: string }): Observable<any> {
        return this.http.put(`${CONTROLLER}/${id}`, payload, {
            context: new HttpContext().set(SKIP_ERROR_TOAST, true),
        }).pipe(
            catchError(this.handleError)
        );
    }

    public canEdit(id: number): Observable<boolean> {
        return this.http.get<any>(`${CONTROLLER}/CanEdit/${id}`).pipe(
            map(response => response.value),
            catchError(this.handleError)
        );
    }

    public updateStatus(id: number): Observable<any> {
        return this.http.put(`${CONTROLLER}/updateStatus/${id}`, null).pipe(
            catchError(this.handleError)
        );
    }

    public getUsedInEnvelope(filter?: SignatoryTypeRoleUsedInEnvelopeFilter): Observable<SignatoryTypeRoleUsedInEnvelope[]> {
        return this.http.post<any>(`${CONTROLLER}/used-in-envelope`, filter ?? null).pipe(
            map(response => response.value),
            catchError(this.handleError)
        );
    }

    private handleError(errorResponse: Response) {
        console.log(errorResponse.statusText);
        return throwError(() => errorResponse || 'Server error');
    }
}